export default {
    title: 'Templates',
    createTemplate: 'Create Template',
    searchPlaceholder: 'Search templates...',
    showingResults: 'Showing {count} results',
    total: 'Total',
    sort: 'Sort',

    all: 'All',
    myTemplates: 'My Templates',
    sharedTemplates: 'Shared Templates',
    favorites: 'Favorites',
    allRegions: 'All Regions',

    sortByUpdated: 'Recently Updated',
    sortByCreated: 'Recently Created',
    sortByNameAsc: 'Name (A-Z)',
    sortByNameDesc: 'Name (Z-A)',

    types: {
        PATENT_APPLICATION: 'Patent Application',
        INVENTION_DISCLOSURE: 'Invention Disclosure',
        OFFICE_ACTION_RESPONSE: 'Office Action Response',
    },

    regions: {
        all: 'All Regions',
        USPTO: 'USPTO',
        EPO: 'EPO',
        PCT: 'PCT',
        CNIPA: 'CNIPA',
        JPO: 'JPO',
        KIPO: 'KIPO',
    },

    technologyArea: {
        general: 'General',
        electrical: 'Electrical',
        mechanical: 'Mechanical',
        chemical: 'Chemical',
        software: 'Software',
        biotech: 'Biotech',
    },

    preview: 'Preview',
    edit: 'Edit',
    editInfo: 'Edit Info',
    editContent: 'Edit Content',
    duplicate: 'Duplicate',
    delete: 'Delete',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    setDefault: 'Set as Default',
    unsetDefault: 'Unset Default',
    defaultTemplate: 'Default Template',
    moreActions: 'More Actions',
    share: 'Share',
    shareTemplate: 'Share',

    source: 'Source',
    system: 'System',
    custom: 'Custom',
    systemTemplate: 'System Template',

    name: 'Name',
    type: 'Type',
    region: 'Region',
    updated: 'Updated',
    actions: 'Actions',

    messages: {
        fetchListFailed: 'Failed to fetch templates',
        fetchDetailFailed: 'Failed to fetch template details',
        createSuccess: 'Template created successfully',
        createFailed: 'Failed to create template',
        updateSuccess: 'Template updated successfully',
        updateFailed: 'Failed to update template',
        deleteSuccess: 'Template deleted successfully',
        deleteFailed: 'Failed to delete template',
        duplicateSuccess: 'Template duplicated successfully',
        duplicateFailed: 'Failed to duplicate template',
        favoriteSuccess: 'Added to favorites',
        favoriteFailed: 'Failed to add to favorites',
        unfavoriteSuccess: 'Removed from favorites',
        unfavoriteFailed: 'Failed to remove from favorites',
        setDefaultSuccess: 'Default template set successfully',
        setDefaultFailed: 'Failed to set default template',
        unsetDefaultSuccess: 'Default template unset successfully',
        unsetDefaultFailed: 'Failed to unset default template',
        shareSuccess: 'Shared successfully',
        shareFailed: 'Failed to share',
        deleteShareSuccess: 'Share deleted successfully',
        deleteShareFailed: 'Failed to delete share',
        updateShareSuccess: 'Share updated successfully',
        updateShareFailed: 'Failed to update share',
    },

    // Share Dialog
    shareDialog: {
        title: 'Share Template',
        shareSettings: 'Share Settings',
        shareType: 'Share Type',
        companyShare: 'Company',
        companyShareName: 'Company',
        personalShare: 'Personal',
        companyShareDesc: 'Share with all company members',
        personalShareDesc: 'Share with specific user',
        selectUser: 'Select User',
        searchUser: 'Search User',
        permission: 'Permission',
        readOnly: 'Read Only',
        editable: 'Editable',
        expiresAt: 'Expires At',
        neverExpires: 'Never',
        expiry7Days: '7 days',
        expiry15Days: '15 days',
        expiry30Days: '30 days',
        setExpireTime: 'Set Expire Time',
        sharedBy: 'Shared By',
        sharedTo: 'Shared To',
        sharedAt: 'Shared At',
        shareList: 'Share List',
        noShares: 'No shares yet',
        createShare: 'Create Share',
        deleteShareConfirm: 'Are you sure to delete this share?',
        cancel: 'Cancel',
        confirm: 'Confirm',
        save: 'Save',
    },

    noTemplates: 'No templates yet',
    noTemplatesDesc: 'Create your first template to get started',
    noResults: 'No matching templates found',
    noResultsDesc: 'Try adjusting your search or filters',

    dialog: {
        createTemplate: 'Create Template',
        createTemplateDesc: 'Select type and set name to create a professional template',
        templateName: 'Template Name',
        templateNamePlaceholder: 'Enter template name',
        templateType: 'Template Type',
        creationMethod: 'Creation Method',
        recommended: 'Recommended',
        blankTemplate: 'Blank Template',
        blankTemplateDesc: 'Start from scratch',
        copyFromExisting: 'Copy Template',
        copyFromExistingDesc: 'Based on existing template',
        referencePatentFullTemplate: 'Generate from Reference Patents',
        referencePatentFullTemplateDesc: 'Create template from full reference patents',
        referenceSourceTitle: 'Reference Sources',
        referenceSourceDesc: 'Select reference patents or upload reference documents, then generate the template automatically.',
        referenceGranularity: 'Granularity',
        referenceGranularityGeneral: 'General',
        referenceGranularityGeneralDesc: 'Simple structure with standard wording for the main text',
        referenceGranularityDetailed: 'Detailed',
        referenceGranularityDetailedDesc: 'Keeps finer placeholders and fill-in template sections',
        referencePatents: 'Reference Patents',
        referencePatentInputPlaceholder: 'Paste patent numbers separated by new lines, commas, or semicolons',
        referenceDocuments: 'Reference Documents',
        referenceDocumentUploadTitle: 'Upload reference patents or style documents',
        referenceDocumentUploadHint: 'Supports PDF and Word',
        referenceFileStatusPending: 'Waiting to parse',
        referenceFileStatusProcessing: 'Parsing',
        referenceFileStatusCompleted: 'Parsed',
        referenceFileStatusFailed: 'Parsing failed',
        referenceFileStatusUnknown: 'Unknown status',
        referenceFilesProcessingHint: 'Reference documents are still being parsed. Generate the template after all documents are ready.',
        referenceFilesFailedHint: 'Reference document parsing failed. Remove the failed file and upload it again.',
        referenceFilesNotReadyHint: 'Reference documents are not ready yet. Generate the template after they are ready.',
        referenceSearch: 'Search and Add',
        referenceSearching: 'Searching',
        referenceRemove: 'Remove',
        referenceElapsed: 'Elapsed {time}',
        referenceEstimatedTime: 'Usually takes 1-2 minutes',
        referenceGenerate: 'Generate Template',
        referenceGenerating: 'Generating...',
        referenceProgressSubmitting: 'Submit Task',
        referenceProgressAnalyzing: 'Analyze Reference Style',
        referenceProgressPreviewing: 'Generate Template Preview',
        referenceProgressConfirming: 'Create Template',
        referenceSubmittingStatus: 'Submitting reference style extraction task...',
        referenceAnalyzingStatus: 'Analyzing reference style...',
        referenceWaitingStatus: 'Waiting for analysis to start...',
        referenceExtractionFailed: 'Failed to extract writing rules',
        referenceTemplateGenerated: 'Template generated',
        referenceGenerateFailed: 'Failed to generate template',
        referenceNoPatentFound: 'No available reference patents found',
        referencePatentDetailFailed: 'Failed to load reference patent details',
        referencePatentsAdded: 'Added {count} reference patents',
        referenceMaxPatentsExceeded: 'Up to {max} reference patents are supported',
        referenceMaxFilesExceeded: 'Up to {max} reference documents are supported',
        referencePatentSearchFailed: 'Failed to search reference patents',
        selectBaseTemplate: 'Select Base Template',
        noTemplatesAvailable: 'No templates available',
        createAndEdit: 'Create & Edit',
        sections: 'Sections',
        cancel: 'Cancel',
        unsavedChangesTitle: 'Unsaved Changes',
        unsavedChangesMessage: 'You have unsaved changes. Are you sure you want to close? Your changes will be lost.',
        discardChanges: 'Discard Changes',
        continueEditing: 'Continue Editing',
        lastUpdated: 'Last Updated',
        noContent: 'No content',
        // Level selection (Super Admin only)
        level: 'Visibility',
        adminOnly: 'Admin Only',
        systemLevel: 'System Level',
        userLevel: 'User Level',
        systemLevelDesc: 'Visible to all users',
        userLevelDesc: 'Visible to me only',
        // Description
        description: 'Description',
        descriptionPlaceholder: 'Briefly describe the purpose and use case of this template...',
        optional: 'Optional',
        // Word import
        importFromWord: 'Import from Word',
        importFromWordDesc: 'Extract sections from .docx',
        uploadWordFile: 'Upload Word Document',
        uploadWordAction: 'Drop .docx file here or click to upload',
        uploadWordHint: 'Supports .docx files with heading-based sections',
        parsing: 'Parsing document...',
        parseSuccess: 'Successfully parsed {count} sections',
        parseFailed: 'Failed to parse document',
        parsedSections: 'Parsed Sections ({count})',
    },

    // Template Editor
    templateEditor: {
        back: 'Back',
        untitledTemplate: 'Untitled Template',
        clickToEdit: 'Click to edit',
        templateType: 'Template Type',
        region: 'Region',
        technologyArea: 'Technology Area',
        from: 'From',
        visibility: 'Visibility',
        private: 'Private',
        library: 'Library',
        saveTemplate: 'Save Template',
        aiInstructions: 'AI Instructions',
        aiInstructionsDesc: 'Define AI instructions for each section to guide content generation that matches your specific requirements.',
        addSection: 'Add Section',
        sectionTitle: 'Section Title',
        insert: 'Insert',
        delete: 'Delete',
        selectInstruction: 'Select Instruction',
        aiInstructionPlaceholder: 'Enter AI instruction for this section...',
        description: 'Description',
        descriptionPlaceholder: 'Describe the template purpose and key features...',
        // Level
        level: 'Visibility',
        // Collapse/Expand buttons
        collapseAll: 'Collapse All',
        expandAll: 'Expand All',
        // Section prompt editor
        aiInstruction: 'AI Instruction',
        linkedInstruction: 'Linked instruction',
        sectionInstruction: 'Section instruction',
        words: 'words',
        fromLibrary: 'From Library',
        remove: 'Remove',
        required: 'Required',
        // Section names
        sections: {
            title: 'Title',
            crossReference: 'Cross-Reference to Related Applications',
            fieldOfInvention: 'Field of Invention',
            background: 'Background',
            summary: 'Summary',
            briefDescription: 'Brief Description of Figures',
            detailedDescription: 'Detailed Description',
            claims: 'Claims',
            abstract: 'Abstract',
            newSection: 'New Section',
        },
        types: {
            patentApplication: 'Patent Application',
            inventionDisclosure: 'Invention Disclosure',
            officeActionResponse: 'Office Action Response',
        },
        messages: {
            nameRequired: 'Please enter a template name',
            updateSuccess: 'Template updated successfully',
            saveSuccess: 'Template saved successfully',
            saveFailed: 'Failed to save template',
            loadFailed: 'Failed to load template',
            insertedPlaceholder: 'Inserted [{title}]',
            readOnlyPermission: 'Permission denied: You have read-only access',
        },
        systemTemplate: 'System Template',
        systemTemplateReadOnly: 'System templates are read-only',
        readOnly: 'Read Only',
        clickToEditName: 'Click to edit name',
    },
};
